import React, { useEffect, useState } from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import { lighten } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  snackbar: {
    borderRadius: 8,
    maxWidth: 500,
    margin: theme.spacing(1),
  },
  snackbarContent: {
    backgroundColor: lighten(theme.palette.error.main, 0.85),
    color: theme.palette.error.main,
    borderRadius: theme.borderRadius.medium,
    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
    padding: theme.spacing(1, 2),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'row',
    '& .MuiSnackbarContent-message': {
      fontSize: '0.9rem',
      fontWeight: 500,
      marginRight: theme.spacing(1),
      display: 'flex',
      alignItems: 'center',
    },
    '& .MuiSnackbarContent-action': {
      marginLeft: 0,
      paddingLeft: 0,
    }
  },
  updateButton: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.common.white,
    minWidth: 120,
    borderRadius: theme.borderRadius.medium,
    textTransform: 'none',
    fontWeight: 'bold',
    fontSize: '0.85rem',
    padding: theme.spacing(0.5, 1.5),
    '&:hover': {
      backgroundColor: theme.palette.error.dark,
    },
  }
}));

const ServiceWorkerUpdate = () => {
  const classes = useStyles();
  const [showReload, setShowReload] = useState(false);

  useEffect(() => {
    const lastNotifiedVersion = localStorage.getItem('swLastNotifiedVersion') || '';

    const onSWUpdate = () => {
      const currentVersion = window.localStorage.getItem("frontendVersion") || '';
      if (currentVersion && currentVersion !== lastNotifiedVersion) {
        setShowReload(true);
        localStorage.setItem('swLastNotifiedVersion', currentVersion);
      }
    };

    window.addEventListener('serviceWorkerUpdated', onSWUpdate);

    const handleMessage = (event) => {
      if (event.data && event.data.type === 'UPDATE_AVAILABLE') {
        const serviceWorkerVersion = event.data.version || '';
        const currentVersion = serviceWorkerVersion || window.localStorage.getItem("frontendVersion") || '';

        if (currentVersion && currentVersion !== lastNotifiedVersion) {
          setShowReload(true);
          localStorage.setItem('swLastNotifiedVersion', currentVersion);
        }
      }
    };

    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener('message', handleMessage);

      const checkInterval = setInterval(() => {
        if (navigator.serviceWorker.controller) {
          navigator.serviceWorker.getRegistration().then(registration => {
            if (registration) {
              registration.update();
            }
          });
        }
      }, 60 * 60 * 1000);

      return () => {
        window.removeEventListener('serviceWorkerUpdated', onSWUpdate);
        navigator.serviceWorker.removeEventListener('message', handleMessage);
        clearInterval(checkInterval);
      };
    }

    return () => {
      window.removeEventListener('serviceWorkerUpdated', onSWUpdate);
    };
  }, []);

  const reloadPage = () => {
    caches.keys().then(function (names) {
      for (let name of names) caches.delete(name);
    });

    window.location.reload(true);
  };

  return (
    <Snackbar
      open={showReload}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      className={classes.snackbar}
      ContentProps={{
        className: classes.snackbarContent,
      }}
      message="Nova versão disponível!"
      action={
        <Button
          className={classes.updateButton}
          size="small"
          onClick={reloadPage}
        >
          ATUALIZAR
        </Button>
      }
    />
  );
};

export default ServiceWorkerUpdate;